module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUBAMAAACQZWsAAAAAJFBMVEU2NjY4ODhHcEw1NTU1NTU1NTU1NTUyMjI1NTU1NTU0NDQ2Nja1h/vVAAAADHRSTlN+IADfX6HLEI9I7zA9Ua6sAAAAd0lEQVQI12NQggMFBiXtNmMgMHMCsb24BYFAMqxIgUFxIUSFBpMCg0oQhK2+SIFBgwmq1VCBQdUJwdaYBGWnA81BMl+TAQqYUNnIapD1IpsJZy9XYFBogjAVjRQY1A0hbNUmoDnO3mA3pwHdrKQYBvKLKZMSivkApTshXYZiMh8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadicon1.png
// module id = Z3a1
// module chunks = 0